<template>
  <el-dialog
    class="deploy-contract-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-descriptions class="margin-top" :column="1" :border="true">
      <el-descriptions-item v-for="(item, i) in list" :key="i">
        <template slot="label">
          {{ item.name }}
        </template>
        <template v-if="item.value === 'Methods'">
          <show-param :list="paramList"></show-param>
        </template>
        <template v-else>
          {{ dataForm[item.value] }}
        </template>
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
import showParam from '../components/showParam'
export default {
  name: 'ContractDetail',
  components: {
    showParam
  },
  data() {
    return {
      title: '查看合约',
      dialogVisible: false,
      list: [
        { name: '合约名称', value: 'name' },
        { name: '状态', value: 'ContractStatus' },
        { name: '当前版本', value: 'version' },
        { name: '虚拟机类', value: 'runtimeType' },
        { name: '合约调用方法(选填)', value: 'Methods' }
      ],
      dataForm: {},
      options: [],
      paramList: []
    }
  },
  mounted() {
    this.getOptions()
  },
  methods: {
    getOptions() {
      //获取虚拟机类型
      this.$apis.chain.getRuntimeTypeList().then(res => {
        if (res.data) {
          let arr = res.data.items
          let newArr = arr.map(ele => {
            let item = {
              label: ele.RuntimeTypeName,
              value: ele.RuntimeTypeType
            }
            return item
          })
          this.options = newArr
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.dataForm = data
      //虚拟机类型
      let item = this.options.filter(ele => ele.value === data.runtimeType)
      this.dataForm.runtimeType = item[0]['label']
      //调用方法
      let arr = data.Methods ? JSON.parse(data.Methods) : []
      this.paramList = arr.map(ele => {
        let item = {
          key: ele.methodName,
          value: ele.methodKey
        }
        return item
      })
      //状态
      let statusArr = [
        '合约初始化',
        '合约升级初始化',
        '合约初始化部署失败',
        '合约初始化合约成功',
        '合约升级失败',
        '合约升级成功',
        '合约冻结失败',
        '合约冻结成功',
        '合约解冻失败',
        '合约解冻成功',
        '合约注销失败',
        '合约注销成功'
      ]
      this.dataForm.ContractStatus = statusArr[data.ContractStatus]
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('deploy-contract-dialog', (), ());
.deploy-contract-dialog.common-dialog {
  @include adaptation((
    --deploy-contract-dialog-body-padding-bottom: 28px
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);

    .el-dialog__body {
      padding-bottom: var(--deploy-contract-dialog-body-padding-bottom);
    }
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
